// init
const { ethers } = require("ethers");
const chain = new ethers.providers.JsonRpcProvider('https://alfajores-forno.celo-testnet.org');
const contractBaseCarbonTonne = '0x4c5f90C50Ca9F849bb75D93a393A4e1B6E68Accb'
const contractNatureCarbonTonne = '0xfb60a08855389F3c0A66b29aB9eFa911ed5cbCB5'
const contractToucanCarbonOffsets = '0xC5b831866d1e48f54B0f7AA267F00A620F25AD80'

// https://app.toucan.earth/contracts
// https://docs.toucan.earth/toucan/dev-resources/smart-contracts/tco2

// contract token
const contractabi = [
  // contract info
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function totalSupply() view returns (uint256)",
  "function redeemAuto2(uint256 amount)",
  "function tokenBalances(address tco2) view returns (uint256)",
  "function retireAndMintCertificate(string calldata retiringEntityString, address beneficiary, string calldata beneficiaryString, string calldata retirementMessage, uint256 amoun) external virtual",
]
// -----------------


export const ContractDetails = async (item) => {
  
  const contract = new ethers.Contract(contractNatureCarbonTonne, contractabi, chain);

  // transaction
  var result = {name: '', ticker: '', total: ''}, err;
  try { 
    result.name = await contract.name();
    result.ticker = await contract.symbol();
    result.total = parseInt(await contract.totalSupply());
  }
  catch (error) { err = error; console.log (error); }  
  
  if (result) console.log(result)

}

export const RedeemAuto2 = async (item) => {
  
  const contract = new ethers.Contract(contractNatureCarbonTonne, contractabi, chain);

  // transaction
  var result, err;
  try { 
    result = await contract.redeemAuto2(parseInt(item));
  }
  catch (error) { err = error; console.log (error); }  
  
  if (result) console.log(result)

}

export const RetireCredits = async (item) => {
  
  const contract = new ethers.Contract(contractToucanCarbonOffsets, contractabi, chain);

  // transaction
  var result, err;
  try { 
    result = await contract.redeemAuto2(parseInt(item));
  }
  catch (error) { err = error; console.log (error); }  
  
  if (result) console.log(result)

}